import { useEffect, useState } from 'react';

export const useWindowFocus = () => {
  const [state, setState] = useState(document.hasFocus());

  useEffect(() => {
    const listener = () => {
      const isVisible = document.hasFocus();
      setState(isVisible);
    };

    window.addEventListener('blur', listener, false);
    window.addEventListener('focus', listener, false);

    return () => {
      window.removeEventListener('blur', listener);
      window.removeEventListener('focus', listener);
    };
  }, []);

  return state;
};
